import(/* webpackMode: "eager" */ "/home/runner/work/Okkanti/Okkanti/src/app/terms/page.tsx");
